export interface WebsitePreset {
  id?: string;
  url: string;
  domain: string;
  riskLevel: 'LOW' | 'MEDIUM' | 'HIGH';
  riskScore: number;
  domainAgeDays: number;
  registrar: string;
  hasHttps: boolean;
  suspiciousRedirects: boolean;
  potentialImpersonation?: string;
  typosquattingDetected: boolean;
  warningSigns: string[];
  safeRecommendations: string[];
}

export const WEBSITE_PRESETS: WebsitePreset[] = [
  {
    id: 'mygov-fake',
    url: 'https://mygov-portal-identity-auth.com',
    domain: 'mygov-portal-identity-auth.com',
    riskLevel: 'HIGH',
    riskScore: 94,
    domainAgeDays: 4,
    registrar: 'NameCheap Privacy Protect / Offshore Registry',
    hasHttps: true,
    suspiciousRedirects: true,
    potentialImpersonation: 'myGov / Services Australia',
    typosquattingDetected: true,
    warningSigns: [
      'Newly registered domain (created only 4 days ago).',
      'Uses official government trademark "myGov" on a non-government .com domain (genuine portal is my.gov.au).',
      'Cloudflare proxy concealing origin server in Eastern Europe.',
      'Contains hidden form fields harvesting Driver Licence and Medicare numbers.'
    ],
    safeRecommendations: [
      'Do not enter login credentials, passwords, or identity details on this website.',
      'Only access Australian government services via official .gov.au web domains.',
      'Report this URL to the Australian Cyber Security Centre (cyber.gov.au).'
    ]
  },
  {
    id: 'linkt-fake',
    url: 'https://linkt-toll-settlement-portal.net',
    domain: 'linkt-toll-settlement-portal.net',
    riskLevel: 'HIGH',
    riskScore: 91,
    domainAgeDays: 12,
    registrar: 'PublicDomainRegistry LLC',
    hasHttps: true,
    suspiciousRedirects: false,
    potentialImpersonation: 'Linkt (Transurban Australia)',
    typosquattingDetected: true,
    warningSigns: [
      'Domain registered 12 days ago with masked registrant details.',
      'Non-standard .net top-level domain for Australian toll road operator (genuine is linkt.com.au).',
      'Pre-fills fake toll invoice numbers and attempts to execute credit card pre-authorizations.'
    ],
    safeRecommendations: [
      'Navigate directly to linkt.com.au or open your official Linkt mobile app.',
      'If you entered payment card details, notify your bank immediately to cancel the card.'
    ]
  },
  {
    id: 'cheap-appliances',
    url: 'https://cheap-appliances-direct-au.xyz',
    domain: 'cheap-appliances-direct-au.xyz',
    riskLevel: 'MEDIUM',
    riskScore: 68,
    domainAgeDays: 28,
    registrar: 'Hostinger Operations, UAB',
    hasHttps: true,
    suspiciousRedirects: false,
    potentialImpersonation: 'Generic Online Retailer',
    typosquattingDetected: false,
    warningSigns: [
      'High-risk discount TLD (.xyz) commonly associated with temporary drop-shipping and scam storefronts.',
      'No valid Australian Business Number (ABN) or physical address verifiable on ABR database.',
      'Requires Direct Bank Deposit (BSB/Account) or cryptocurrency payment at checkout.'
    ],
    safeRecommendations: [
      'Exercise caution before purchasing. Check reviews on ProductReview.com.au or Trustpilot.',
      'Verify the ABN on abr.business.gov.au before sending bank transfers.',
      'Use secure payment methods offering buyer protection (PayPal, Credit Card).'
    ]
  },
  {
    id: 'commbank-legit',
    url: 'https://www.commbank.com.au',
    domain: 'commbank.com.au',
    riskLevel: 'LOW',
    riskScore: 4,
    domainAgeDays: 10420,
    registrar: 'CSC Corporate Domains (Australia)',
    hasHttps: true,
    suspiciousRedirects: false,
    potentialImpersonation: undefined,
    typosquattingDetected: false,
    warningSigns: [],
    safeRecommendations: [
      'Domain is the verified official Commonwealth Bank of Australia portal.',
      'Valid Extended Validation / Organization Validated SSL Certificate.',
      'Always ensure the URL matches exact address before typing NetBank passwords.'
    ]
  },
  {
    id: 'services-australia-legit',
    url: 'https://www.servicesaustralia.gov.au',
    domain: 'servicesaustralia.gov.au',
    riskLevel: 'LOW',
    riskScore: 2,
    domainAgeDays: 5200,
    registrar: 'Gov.au Domain Administration (auDA)',
    hasHttps: true,
    suspiciousRedirects: false,
    potentialImpersonation: undefined,
    typosquattingDetected: false,
    warningSigns: [],
    safeRecommendations: [
      'Official Australian Federal Government domain (.gov.au restricted to verified agencies).',
      'Safe for accessing Medicare, Centrelink, and Child Support information.'
    ]
  }
];
